/* © CNES */
import { Vector as VectorSource } from 'ol/source';

/**
 * Vector source.
 */
function vector({ features }: { features: any }) {
  return new VectorSource({
    features,
  });
}

export default vector;
